package com.eladfinish.bible.contest.features.copyOptions.model

enum class CopyOptionsOperation {
    COPY_TEXT,
    SAVE_FILE,
}
